<template>
  <div :class="className + ' my_dialog'">
    <div class="e_dialog_content">
      <div class="e_content">
        <h3 v-if="title" class="e_title fw_bold">{{ title }}</h3>
        <slot />
      </div>
      <div class="e_content_footer">
        <div
          v-show="showCancelButton"
          class="e_cancel fw_bold"
          @click="cancelEvent"
        >{{ cancelButtonText }}</div>
        <div
          v-show="showConfirmButton"
          class="e_confirm fw_bold"
          @click="confirmEvent"
        >{{ confirmButtonText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, toRefs } from 'vue'
export default {
  name: 'EDialog',
  props: {
    isShow: { // 是否展示
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: 'e_dialog'
    },
    showConfirmButton: { // 是否展示确认按钮
      type: Boolean,
      default: true
    },
    confirmButtonText: { // 确认按钮文案
      type: String,
      default: '确认'
    },
    showCancelButton: { // 是否展示取消按钮
      type: Boolean,
      default: true
    },
    cancelButtonText: { // 取消按钮文案
      type: String,
      default: '取消'
    }
  },
  setup(props, context) {
    const state = reactive({

    })
    onMounted(() => {

    })
    const cancelEvent = () => {
      context.emit('getCancelEvent', 'cancel')
    }
    const confirmEvent = () => {
      context.emit('getConfirmEvent', 'confirm')
    }

    return {
      ...toRefs(state),
      cancelEvent,
      confirmEvent
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes my_opacity {
  0%{ opacity: 0;}
  100% { opacity: 1;}
}

.my_dialog{
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.7);
  box-sizing: border-box;
  animation: my_opacity 0.8s;
  transform: translate3d(0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .e_dialog_content{
    width: 320px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    top: 45%;
    left: 50%;
    // transform: translateX(-50%) translateY(-50%);
    transform: translate3d(-50%, -50%, 0);
    backface-visibility: hidden;
    transition: 0.3s;
    transition-property: transform, opacity;
    .e_content{
      overflow-y: auto;
      max-height: 500px;
    }
    .e_title{font-size: 16px; text-align: center; padding: 20px 0;}
  }
  .e_content_footer{
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: 16px;
    border-top: 0.5px solid #e5e5e5;
    .e_confirm, .e_cancel{padding: 12px 0;}
    .e_confirm{color: #C99700;}
  }
}
</style>
